<template>
  <section id="case-studies" class="tw-py-20 tw-bg-white">
    <div class="tw-container tw-mx-auto tw-px-4">
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-12 tw-items-center">
        <!-- Left - Image -->
        <div class="tw-rounded-xl tw-overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=1000&h=700&fit=crop&q=90" 
            alt="Trade Show Event"
            class="tw-w-full tw-h-full tw-object-cover"
            loading="lazy"
          />
        </div>

        <!-- Right - Content -->
        <div class="tw-space-y-6">
          <div>
            <h2 class="tw-text-3xl tw-font-bold tw-text-gray-900 tw-mb-3">
              Virtual Food Trade Show
            </h2>
            <p class="tw-text-gray-600">
              From 1,200 Attendees to 3,400+ Qualified Meetings
            </p>
          </div>

          <div class="tw-space-y-4">
            <div>
              <h3 class="tw-font-semibold tw-text-gray-900 tw-mb-1">Challenge</h3>
              <p class="tw-text-gray-600 tw-text-sm">
                Low meeting completion rates and poor attendee engagement.
              </p>
            </div>

            <div>
              <h3 class="tw-font-semibold tw-text-gray-900 tw-mb-1">Solution</h3>
              <p class="tw-text-gray-600 tw-text-sm">
                Intelligent matching and automated scheduling.
              </p>
            </div>
          </div>

          <div>
            <h3 class="tw-font-semibold tw-text-gray-900 tw-mb-4">Results</h3>
            <div class="tw-grid tw-grid-cols-3 tw-gap-4">
              <div class="tw-text-center">
                <div class="tw-text-3xl tw-font-bold tw-text-primary-600 tw-mb-1">3.4K+</div>
                <div class="tw-text-xs tw-text-gray-500 tw-uppercase">Meetings</div>
              </div>
              <div class="tw-text-center">
                <div class="tw-text-3xl tw-font-bold tw-text-green-600 tw-mb-1">89%</div>
                <div class="tw-text-xs tw-text-gray-500 tw-uppercase">Complete</div>
              </div>
              <div class="tw-text-center">
                <div class="tw-text-3xl tw-font-bold tw-text-blue-600 tw-mb-1">+42%</div>
                <div class="tw-text-xs tw-text-gray-500 tw-uppercase">Satisfaction</div>
              </div>
            </div>
          </div>

          <div class="tw-border-l-4 tw-border-primary-600 tw-pl-4">
            <p class="tw-text-gray-700 tw-text-sm tw-italic tw-mb-1">
              "TopEshows transformed our event. The matchmaking was spot-on."
            </p>
            <p class="tw-text-gray-600 tw-text-sm">— Event Organizer</p>
          </div>

          <a
            :href="appConfig.calendlyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="tw-inline-block tw-bg-primary-600 tw-text-white tw-px-6 tw-py-2.5 tw-rounded-lg tw-font-semibold hover:tw-bg-primary-700 tw-transition-colors"
          >
            Get More Details
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>
